var angular = require('angular');
angular.module('pitch.app')
.controller('TrackInfoModalCtrl', function($scope, $rootScope, Track, Territory, TerritoryControl, Nps, Tags, Chart, $timeout, UserTerritory, Auth, Lyrics, config) {
    "use strict";

    $scope.init = function(track) {
        Track.get({
            id: track.id
        }, function(resp) {
            $scope.trackDetails = resp;
        });

        Tags.query({
            trackId: track.id
        }, function(r) {
            $scope.tags = r;

            //group the tags by keyword type
            var keywordTypes = {};
            angular.forEach(r, function(t) {
                var i = t.keyword.path.indexOf(':');
                var keywordType = t.keyword.path.substring(0, i);
                keywordTypes[keywordType] = keywordTypes[keywordType] || [];
                keywordTypes[keywordType].push(t.keyword.path.substring(i + 1));
            });

            $scope.keywordTypes = keywordTypes;
        });

        if (track.tempo_song_id) {
            // if you can't see all territories, the you jolly well can't sync control either!
            Auth.acl('territories_view')
                .then(function(isGranted) {
                    if (isGranted) {
                        Territory.query(function (r) {
                            $scope.territories = r;
                        });
                    } else {
                        UserTerritory.get({}, function(resp) {
                            $scope.territories = [resp];
                        });
                    }
                });

            //this should be filtered
            TerritoryControl.query({
                tempoSongId: track.tempo_song_id
            }, function(resp) {
                $scope.territoryControl = resp;
            });
            Nps.query({
                tempoSongId: track.tempo_song_id
            }, function(resp) {
                $scope.nps = resp;
            });
        }

        Chart.query({
            trackId: track.id
        }, function(r) {
            $scope.charts = r;
        });

        Lyrics.get({
            trackId: track.id
        }, function(resp) {
            $scope.lyrics = resp;
        });
    };

     $scope.getTerritoryControl = function(territory) {
        //return undefined so that the :: expression doesn't remove the watch
        //@see https://docs.angularjs.org/guide/expression
        if (!$scope.territoryControl) {
            return undefined;
        }

        for (var i = 0; i < $scope.territoryControl.length; i++) {
            var tc = $scope.territoryControl[i];
            if (tc.territory.id === territory.id) {
                return tc.percentage;
            }
        }

        return 0;
    };


    $scope.getSyncTerritoryControl = function(territory) {
        //return undefined so that the :: expression doesn't remove the watch
        //@see https://docs.angularjs.org/guide/expression
        if (!$scope.territoryControl) {
            return undefined;
        }

        for (var i = 0; i < $scope.territoryControl.length; i++) {
            var tc = $scope.territoryControl[i];
            if (tc.territory.id === territory.id) {
                return tc.sync_percentage;
            }
        }

        return 0;
    };

    $scope.getNps = function(territory) {
        //return undefined so that the :: expression doesn't remove the watch
        //@see https://docs.angularjs.org/guide/expression
        if (!$scope.nps) {
            return undefined;
        }

        for (var i = 0; i < $scope.nps.length; i++) {
            var npsItem = $scope.nps[i];
            if (npsItem.territory.id === territory.id) {
                return npsItem.nps;
            }
        }

        return 0;
    };

    $scope.downloadLyrics = function(track){
        $rootScope.$emit('MEDIA_DOWNLOAD_READY', {
            _links: {
                download: config.apiUri + '/tracks/' + track.id + '/lyricstext'
            }
        });
    };
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/TrackInfoModalCtrl.js